import React from "react";
import { Button, Result, notification } from "antd";
import { useTranslation } from "react-i18next";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const OrderDuplicated = () => {
  const { t } = useTranslation();
  const handleClearLocalStorageAction = () => {
    try {
      const prefix = "SalesPark-Checkout-v2";

      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (key && key.startsWith(prefix)) {
          localStorage.removeItem(key);
        }
      }
      // Assumindo que 'message' do Ant Design foi importado e está disponível no escopo
      notification.info({ message: t("orderDuplicated.retryingNotification") });

      return true;

      // Error handling
    } catch (error) {
      console.error("Erro ao limpar localStorage:", error);
      return false;
    }
  };

  const retryOperation = async () => {
    try {
      handleClearLocalStorageAction();
      await delay(1000); // Aguardar 1 segundo antes de recarregar a página
      window.location.reload();

      // Se a operação falhar, notificar o usuário
    } catch (error) {
      console.error("Erro ao tentar novamente:", error);
      notification.error({ message: t("orderDuplicated.failedNotification") });
    }
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", paddingTop: 25 }}>
        <img className="img-fluid" src={"/img/logo-white.png"} alt="" />
      </div>
      <Result
        status="500"
        title={t("orderDuplicated.title")}
        subTitle={t("orderDuplicated.subTitle")}
        extra={
          <div>
            <Button type="primary" onClick={() => retryOperation()}>
              {t("orderDuplicated.retryButton")}
            </Button>
          </div>
        }
      />
    </>
  );
};

export default OrderDuplicated;
